import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaGlobe } from "react-icons/fa";
import styles from "./WhyChooseUs.module.css";

const reasons = [
    { text: "Innovative Solutions: We bring cutting-edge technology to solve complex business challenges." },
    { text: "Expert Team: Our team consists of highly skilled data scientists, AI engineers, and business consultants." },
    { text: "Custom Strategies: We offer tailor-made solutions designed to meet the unique needs of your organization." },
    { text: "Scalability & Growth: Our solutions are built to scale with your business and support long-term growth." },
];

const WhyChooseUs = () => {
    return (
        <div className={styles.whyChooseContainer}>
            <motion.div className={styles.whyChooseSection} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
                <h2 className={styles.sectionTitle}>Why Choose Quantabiz?</h2>
                <ul className={styles.reasonList}>
                    {reasons.map((reason, index) => (
                        <motion.li
                            key={index}
                            className={styles.reasonItem}
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.2 }}
                            viewport={{ once: true }}
                        >
                            <FaCheckCircle className={styles.checkIcon} /> {reason.text}
                        </motion.li>
                    ))}
                </ul>
            </motion.div>

            <motion.div className={styles.contactSection} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.2 }}>
                <h2 className={styles.sectionTitle}>Get in Touch</h2>
                <div className={styles.contactDetails}>
                    <p><FaMapMarkerAlt className={styles.contactIcon} /> <strong>Location:</strong> GT - 08, Sector - 117, Noida, 201307</p>
                    <p><FaEnvelope className={styles.contactIcon} /> <strong>Email:</strong> contact@quantabiz.in</p>
                    <p><FaPhoneAlt className={styles.contactIcon} /> <strong>Phone:</strong> +91-9999648406</p>
                    <p><FaGlobe className={styles.contactIcon} /> <strong>Website:</strong> <a href="https://www.quantabiz.in" target="_blank" rel="noopener noreferrer">www.quantabiz.in</a></p>
                </div>
                <p className={styles.innovationText}>
                    Join hands with Quantabiz to unlock the power of data and transform your business for the future. Let's innovate together!
                </p>
            </motion.div>
        </div>
    );
};

export default WhyChooseUs;
